<template>
  <aha-modal
    :title="$i18nPresenter.t('Your AhaSlides Plan has been updated!')"
    @hide="handleCloseModal('Close')"
    noCloseOnBackdrop
  >
    <div>
      <div class="box-legacy font-bold">
        <p>🎉 {{ $i18nPresenter.t('Your audience size has been increased.') }}</p>
        <div>
          <span class="box-user"><i class="fas fa-user mr-1"></i> {{ planBenefit.legacyInfo.legacyMaxAudience }}</span>
          <span class="ml-4 mr-4"><i class="fas fa-arrow-right"></i></span>
          <span class="box-user to"><i class="fas fa-user mr-1"></i> {{ planBenefit.maxAudience }}</span>
        </div>
      </div>
      <p>{{ textNote }}</p>
    </div>
    <template #action>
      <aha-link
        @click="handleCloseModal('Got it')"
        class="font-bold"
      >
        {{ $i18nPresenter.t('Got it') }}
      </aha-link>
      <aha-button
        variant="primary"
        has-margin-left
        @click="handleLearmore()"
      >
        {{ $i18nPresenter.t('Learn more') }} <i class="fas fa-external-link-alt ml-2"></i>
      </aha-button>
    </template>
  </aha-modal>
</template>

<script>
// @ is an alias to /src
import { mapState } from 'vuex'
// import Utils from '@/util'
import UserApi from '@/api/user'
import Util from '@/util'

export default {
  name: 'HandlePlanLegacy',
  data() {
    return {
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      planBenefit: (state) => state.planBenefit,
    }),
    textNote() {
      if (this.planBenefit.name === 'free') {
        return this.$i18nPresenter.t('Your account remains free. Enjoy!')
      }
      return this.$i18nPresenter.t('Everything else, including the pricing, remains the same as long as you keep this subscription active. Enjoy!')
    },
  },
  methods: {
    async handleCloseModal(type) {
      this.$store.state.currentUser.personalInformation = this.currentUser.personalInformation || {}
      this.$store.state.currentUser.personalInformation.isShowedModalLegacyInfor = true
      this.$store.dispatch('setCurrentUserAction', this.$store.state.currentUser)
      await UserApi.patchUserById(this.currentUser.id, {
        personalInformation: this.$store.state.currentUser.personalInformation,
      })
      if (type) {
        Util.mixpanelTracking(
          'Presentation List',
          `Plan has been update pop-up > ${type}`,
          null,
          null,
          {
            userId: this.$store.state.currentUser.id,
            plan: this.$store.state.currentUser.plan,
          },
        )
      }
    },
    handleLearmore() {
      this.handleCloseModal()
      Util.mixpanelTracking(
        'Presentation List',
        'Plan has been update pop-up > Learn more',
        null,
        null,
        {
          userId: this.$store.state.currentUser.id,
          plan: this.$store.state.currentUser.plan,
        },
      )
      window.open('https://help.ahaslides.com/portal/en/kb/articles/legacy-plan', '_blank')
    },
  },
}
</script>

<style lang="scss" scoped>
.box-legacy {
  background-color: #F2F7FF;
  border-radius: 4px;
  padding: 32px 16px;
  margin-bottom: 16px;
  text-align: center;

  p {
    color: #282E3E;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 16px;
  }

  span {
    display: inline-block;
    vertical-align: middle;
    &.box-user {
      background-color: #fff;
      padding: 8px 16px;
      border: 1px solid #D3D7E1;
      border-radius: 32px;

      &.to {
        border-color: #33C173;
        color: #33C173;
        box-shadow: 0px 0px 16.77px 0px #33C1734D;
      }
    }
  }
}
</style>
